import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { LinkIcon } from "lucide-react";

interface TherapistFieldsProps {
  websiteUrl: string;
  bookingCalendarUrl: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TherapistFields = ({ websiteUrl, bookingCalendarUrl, onChange }: TherapistFieldsProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="websiteUrl">Website URL (optional)</Label>
      <div className="flex">
        <span className="flex items-center px-3 bg-gray-50 border border-r-0 border-input rounded-l-md">
          <LinkIcon className="h-4 w-4 text-muted-foreground" />
        </span>
        <Input 
          id="websiteUrl" 
          name="websiteUrl" 
          type="url" 
          placeholder="https://yourwebsite.com" 
          value={websiteUrl} 
          onChange={onChange} 
          className="border-[#CCCCCC] focus:border-[#3BAFDA] rounded-l-none bg-[#E8F0F8]" 
        />
      </div>
      <p className="text-xs text-muted-foreground mt-1">
        Add your professional website URL to help clients learn more about your services.
      </p>
      <div style={{ height: '24px' }} />
      <Label htmlFor="bookingCalendar" className="block">Booking Calendar Link (optional)</Label>
      <div className="flex">
        <span className="flex items-center px-3 bg-gray-50 border border-r-0 border-input rounded-l-md">
          <LinkIcon className="h-4 w-4 text-muted-foreground" />
        </span>
        <Input 
          id="bookingCalendar" 
          name="bookingCalendar" 
          type="url" 
          placeholder="https://calendly.com/your-link" 
          value={bookingCalendarUrl} 
          onChange={onChange} 
          className="border-[#CCCCCC] focus:border-[#3BAFDA] rounded-l-none bg-[#E8F0F8]" 
        />
      </div>
      <p className="text-xs text-muted-foreground mt-1">
        Add a link to your booking calendar (e.g., Calendly, Doodle, etc.) so clients can book sessions directly.
      </p>
    </div>
  );
};

export default TherapistFields;
